import { render, staticRenderFns } from "./addfromTalentPool.vue?vue&type=template&id=5bfe0e24&scoped=true&"
import script from "./addfromTalentPool.vue?vue&type=script&lang=js&"
export * from "./addfromTalentPool.vue?vue&type=script&lang=js&"
import style0 from "./addfromTalentPool.vue?vue&type=style&index=0&id=5bfe0e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe0e24",
  null
  
)

export default component.exports